module.exports = __webpack_public_path__ + "img/title-bj.039b00af.jpg";